<template>
  <div class="w-full h-full">
    <form
      @submit.prevent="submitDocument"
      @click.stop
      class="w-full h-auto bg-white p-5"
    >
      <div class="flex flex-col gap-3 lg:gap-5">
        <div class="flex flex-col gap-3">
          <div class="flex justify-between items-center">
            <h2 class="text-xl font-semibold capitalize text-heading">
              Douments Needed
            </h2>
            <button
              v-if="submitAdditional == true"
              @click="toggleEdit"
              type="button"
              class="px-5 py-1 btn text-[16px] rounded-md"
            >
              Edit
            </button>
            <button
              v-if="toggle_edit == true"
              @click="
                disableStatus = true;
                submitAdditional = true;
                toggle_edit = false;
              "
              type="button"
              class="px-5 py-1 btn text-[16px] rounded-md"
            >
              Close
            </button>
          </div>
          <div class="w-full flex flex-col gap-3 lg:gap-6">
            <div class="flex flex-col gap-3 lg:flex-row lg:justify-between">
              <div class="w-full flex flex-col gap-3">
                <label for="aadhar_card" class="text-sm labelcolor"
                  >Upload Recent Passport Size Photograph
                  <span class="span-color">*</span></label
                >
                <input
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                  type="file"
                  id="photo_file"
                  @change="onFileUpload('photo', $event)"
                  :disabled="disableStatus"
                  accept="image/png, image/jpeg, image/jpg"
                  class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  required
                />
                <a
                  v-if="upload_photo_show === true"
                  :href="passport_photo"
                  target="_blank"
                  :download="passport_photo"
                  class="text-sm text-gray-600"
                  rel="noopener noreferrer"
                >
                  Open Passport Photo
                </a>
                <p class="form-para break-words leading-normal">
                  Only images with .jpeg or .jpg, .png extension allowed. Size
                  should be uploaded 3 MB.
                </p>
              </div>
              <div class="w-full flex flex-col gap-3">
                <label for="birth_proof" class="text-sm labelcolor"
                  >Date Of Birth Proof <span class="span-color">*</span></label
                >
                <input
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                  type="file"
                  id="birth_proof"
                  @change="onFileUpload('birth', $event)"
                  :disabled="disableStatus"
                  accept="image/png, image/jpeg, image/jpg"
                  class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  required
                /><a
                  v-if="upload_dob_show === true"
                  :href="dob"
                  target="_blank"
                  class="text-sm text-gray-600"
                  rel="noopener noreferrer"
                >
                  Open Date Of Birth Proof
                </a>
                <div>
                  <p class="form-para break-words leading-normal">
                    Only images with .jpeg or .jpg, .png extension allowed. Size
                    should be uploaded 3 MB.
                  </p>
                  <p class="form-para break-words leading-normal">
                    The list of acceptable documents are AADHAR CARD(ONLY IF
                    INDIAN NATIONALITY),VOTER IDENTITY CARD,DRIVING LICENCE, PAN
                    CARD,PASSPORT
                  </p>
                </div>
              </div>
              <div class="w-full flex flex-col gap-3">
                <label for="10th_marksheet" class="text-sm labelcolor"
                  >10th Mark Sheet <span class="span-color">*</span></label
                >
                <input
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                  type="file"
                  id="10th_marksheet"
                  @change="onFileUpload('tenth', $event)"
                  :disabled="disableStatus"
                  accept=".jpg, .jpeg, .pdf"
                  class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  required
                />
                <a
                  v-if="upload_tenth_show === true"
                  :href="tenth"
                  target="_blank"
                  class="text-sm text-gray-600"
                  rel="noopener noreferrer"
                >
                  Open 10th Mark Sheet
                </a>
                <p class="form-para break-words leading-normal">
                  Max upload limit 3 MB & in PDF, .jpeg or .jpg format only.Size
                  should be applied between 50 KB to 3 MB.less than or more than
                  the give size will be rejected
                </p>
              </div>
            </div>
            <!-- 12th mark sheet  -->
            <div class="flex flex-col gap-3 lg:flex-row lg:justify-between">
              <div class="w-full flex flex-col gap-3">
                <label for="12th_marksheet" class="text-sm labelcolor"
                  >12th Mark Sheet <span class="span-color">*</span></label
                >
                <input
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                  type="file"
                  id="12th_marksheet"
                  @change="onFileUpload('tweleth', $event)"
                  :disabled="disableStatus"
                  accept=".jpg, .jpeg, .pdf"
                  class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  required
                />
                <a
                  v-if="upload_tweleth_show === true"
                  :href="tweleth"
                  target="_blank"
                  class="text-sm text-gray-600"
                  rel="noopener noreferrer"
                >
                  Open 12th Mark Sheet
                </a>
                <p class="form-para break-words leading-normal">
                  Max upload limit 3 MB & in PDF, .jpeg or .jpg format only.Size
                  should be applied between 50 KB to 3 MB.less than or more than
                  the give size will be rejected
                </p>
              </div>
              <div class="w-full flex flex-col gap-3">
                <label for="aadhar_card" class="text-sm input_label"
                  >Upload Aadhar Card <span class="span-color">*</span></label
                >
                <input
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                  type="file"
                  :disabled="disableStatus"
                  @change="onFileUpload('aadhar', $event)"
                  accept=".jpg, .jpeg, .pdf"
                  class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  required
                />
                <a
                  v-if="upload_aadhar_show === true"
                  :href="aadhar"
                  target="_blank"
                  class="text-sm text-gray-600"
                  rel="noopener noreferrer"
                >
                  Open Aadhar Card
                </a>
                <p class="text-[10px] input_text break-words leading-normal">
                  Max upload limit 3 MB & in PDF, ..jpeg or ..jpgformat
                  only.Size should be applied between 50 KB to 3 MB.less than or
                  more than the give size will be rejected
                </p>
              </div>
              <div class="w-full flex flex-col gap-3">
                <label for="pan_card" class="text-sm input_label"
                  >Upload Pan card <span class="span-color">*</span></label
                >
                <input
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                  type="file"
                  :disabled="disableStatus"
                  @change="onFileUpload('pan', $event)"
                  accept=".jpg, .jpeg, .pdf"
                  class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  required
                />
                <a
                  v-if="upload_pan_show === true"
                  :href="pan"
                  target="_blank"
                  :download="pan"
                  class="text-sm text-gray-600"
                  rel="noopener noreferrer"
                >
                  Open Pan card
                </a>
                <p class="text-[10px] input_text break-words leading-normal">
                  Max upload limit 3 MB & in PDF, ..jpeg or ..jpgformat
                  only.Size should be applied between 50 KB to 3 MB.less than or
                  more than the give size will be rejected
                </p>
              </div>
            </div>

            <!-- caste kyc and other documents  -->
            <div class="flex flex-col gap-3 lg:flex-row lg:justify-between">
              <div class="w-full flex flex-col gap-3">
                <label for="caste_upload" class="text-sm labelcolor"
                  >Upload Caste Certificate
                  <span class="span-color">*</span></label
                >
                <input
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                  type="file"
                  id="caste_upload"
                  @change="onFileUpload('caste', $event)"
                  :disabled="disableStatus"
                  accept=".jpg, .jpeg, .pdf"
                  class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  required
                />
                <a
                  v-if="upload_caste_show === true"
                  :href="caste"
                  target="_blank"
                  class="text-sm text-gray-600"
                  rel="noopener noreferrer"
                >
                  Open Caste Certificate
                </a>
                <p class="form-para break-words leading-normal">
                  Max upload limit 3 MB & in PDF, .jpeg or .jpg format only.Size
                  should be applied between 50 KB to 3 MB.less than or more than
                  the give size will be rejected
                </p>
              </div>
              <div class="w-full flex flex-col gap-3">
                <label for="kyc_document" class="text-sm labelcolor"
                  >Upload KYC Document <span class="span-color">*</span></label
                >
                <input
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                  type="file"
                  id="kyc_document"
                  @change="onFileUpload('kyc', $event)"
                  :disabled="disableStatus"
                  accept=".jpg, .jpeg, .pdf"
                  class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  required
                />
                <a
                  v-if="upload_kyc_show === true"
                  :href="kyc"
                  target="_blank"
                  class="text-sm text-gray-600"
                  rel="noopener noreferrer"
                >
                  Open KYC Document
                </a>
                <div>
                  <p class="form-para break-words leading-normal">
                    Max upload limit 3 MB & in PDF, .jpeg or .jpg format
                    only.Size should be applied between 50 KB to 3 MB.less than
                    or more than the give size will be rejected
                  </p>
                </div>
              </div>
              <div class="w-full flex flex-col gap-3">
                <label
                  for="others_document"
                  class="text-sm labelcolor capitalize"
                  >Other Supporting document
                  <span class="span-color">*</span></label
                >
                <input
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                  type="file"
                  id="others_document"
                  @change="onFileUpload('others', $event)"
                  :disabled="disableStatus"
                  accept=".jpg, .jpeg, .pdf"
                  class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  required
                />
                <a
                  v-if="upload_other_show === true"
                  :href="others"
                  target="_blank"
                  download
                  class="text-sm text-gray-600 flex gap-2"
                  rel="noopener noreferrer"
                >
                  Open Supporting document
                  <!-- <span class="flex items-center">
                    <img :src="download_file" alt="download file" class="w-5 h-5 object-contain" />
                  </span> -->
                </a>
                <p class="form-para break-words leading-normal">
                  Max upload limit 3 MB & in PDF, .jpeg or .jpg format only.Size
                  should be applied between 50 KB to 3 MB.less than or more than
                  the give size will be rejected
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="flex justify-between w-full">
          <div class="text-success text-xl">
            <p v-if="message">{{ message }}</p>
          </div>
          <div
            v-if="submit_button == false"
            class="flex justify-end items-center"
          >
            <button
              :disabled="disableStatus"
              type="submit"
              class="px-5 py-1 btn text-[16px] rounded-md"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "DocumentsView",
  data() {
    return {
      file_photo: null,
      file_birth: null,
      file_sslc: null,
      file_hsc: null,
      file_caste: null,
      file_kyc: null,
      file_other: null,
      file_aadhar: null,
      file_pan: null,
      submitAdditional: false,
      disableStatus: false,
      message: "",
      passport_photo: "",
      dob: "",
      tenth: "",
      tweleth: "",
      caste: "",
      kyc: "",
      others: "",
      aadhar: "",
      pan: "",
      download_file: require(`${process.env.VUE_APP_DOWNLOAD_FILE}`),
      upload_photo_show: false,
      upload_dob_show: false,
      upload_tenth_show: false,
      upload_tweleth_show: false,
      upload_caste_show: false,
      upload_kyc_show: false,
      upload_other_show: false,
      upload_aadhar_show: false,
      upload_pan_show: false,
      completed: false,
      toggle_edit: false,
      submit_button: false,
      error_message: "",
    };
  },
  computed: {
    ...mapGetters(["userInfo", "isAuthenticated"]),
  },
  created() {
    this.fetchDocuments();
  },
  methods: {
    onFileUpload(type, event) {
      const file = event.target.files[0];
      const maxFileSize = 3 * 1024 * 1024;
      const minFileSize = 50 * 1024;
      if (file.size > maxFileSize) {
        alert("File size exceeds 3MB. Please upload a smaller file.");
        event.target.value = "";
        return;
      }
      if (file.size < minFileSize) {
        alert(
          "File size minimun 50kb. Please upload a larger file size between 50 KB to 3 MB."
        );
        event.target.value = "";
        return;
      }
      if (type === "photo") {
        this.file_photo = file;
        this.upload_photo_show = false;
        if (this.toggle_edit == true) {
          let formData = new FormData();
          formData.append("passport_photo", this.file_photo);
          axios
            .patch(
              `${process.env.VUE_APP_API}/update/passport-photo/${this.userInfo.data.user.id}/?Key=${this.userInfo.data.token}`,
              formData
            )

            .then((resp) => {
              if (resp.data.status == 200) {
                this.message = resp.data.message;
                this.fetchPhoto();

                // this.submitAdditional = true;
                // this.disableStatus = true;

                setTimeout(() => {
                  this.message = "";
                }, 3000);
              }
            })
            .catch((err) => {
              console.log("error", err);
            });
        }
      } else if (type === "birth") {
        this.file_birth = file;
        this.upload_dob_show = false;
        if (this.toggle_edit == true) {
          let formData = new FormData();
          formData.append("dob_proof", this.file_birth);
          axios
            .patch(
              `${process.env.VUE_APP_API}/update/dob-proof/${this.userInfo.data.user.id}/?Key=${this.userInfo.data.token}`,
              formData
            )

            .then((resp) => {
              if (resp.data.status == 200) {
                this.message = resp.data.message;
                // this.submitAdditional = true;
                // this.disableStatus = true;
                this.fetchDob();
                setTimeout(() => {
                  this.message = "";
                }, 3000);
              }
            })
            .catch((err) => {
              console.log("error", err);
            });
        }
      } else if (type === "tenth") {
        this.file_sslc = file;
        this.upload_tenth_show = false;
        if (this.toggle_edit == true) {
          let formData = new FormData();
          formData.append("tenth_marksheet", this.file_sslc);
          axios
            .patch(
              `${process.env.VUE_APP_API}/update/tenth-marksheet/${this.userInfo.data.user.id}/?Key=${this.userInfo.data.token}`,
              formData
            )

            .then((resp) => {
              if (resp.data.status == 200) {
                this.message = resp.data.message;
                // this.submitAdditional = true;
                // this.disableStatus = true;
                this.fetchTenth();
                setTimeout(() => {
                  this.message = "";
                }, 3000);
              }
            })
            .catch((err) => {
              console.log("error", err);
            });
        }
      } else if (type === "tweleth") {
        this.file_hsc = file;
        this.upload_tweleth_show = false;

        if (this.toggle_edit == true) {
          let formData = new FormData();
          formData.append("twelth_marksheet", this.file_hsc);
          axios
            .patch(
              `${process.env.VUE_APP_API}/update/twelth-marksheet/${this.userInfo.data.user.id}/?Key=${this.userInfo.data.token}`,
              formData
            )

            .then((resp) => {
              if (resp.data.status == 200) {
                this.message = resp.data.message;
                // this.submitAdditional = true;
                // this.disableStatus = true;
                this.fetchTweleth();
                setTimeout(() => {
                  this.message = "";
                }, 3000);
              }
            })
            .catch((err) => {
              console.log("error", err);
            });
        }
      } else if (type === "caste") {
        this.file_caste = file;
        this.upload_caste_show = false;

        if (this.toggle_edit == true) {
          let formData = new FormData();
          formData.append("caste_certificate", this.file_caste);
          axios
            .patch(
              `${process.env.VUE_APP_API}/update/caste-certificate/${this.userInfo.data.user.id}/?Key=${this.userInfo.data.token}`,
              formData
            )

            .then((resp) => {
              console.log("formData", formData);
              if (resp.data.status == 200) {
                this.message = resp.data.message;
                // this.submitAdditional = true;
                // this.disableStatus = true;
                this.fetchCaste();
                setTimeout(() => {
                  this.message = "";
                }, 3000);
              }
            })
            .catch((err) => {
              console.log("error", err);
            });
        }
      } else if (type === "kyc") {
        this.file_kyc = file;
        this.upload_kyc_show = false;

        if (this.toggle_edit == true) {
          let formData = new FormData();
          formData.append("kyc_proof", this.file_kyc);
          axios
            .patch(
              `${process.env.VUE_APP_API}/update/kyc-proof/${this.userInfo.data.user.id}/?Key=${this.userInfo.data.token}`,
              formData
            )

            .then((resp) => {
              if (resp.data.status == 200) {
                this.message = resp.data.message;
                // this.submitAdditional = true;
                // this.disableStatus = true;
                this.fetchKyc();
                setTimeout(() => {
                  this.message = "";
                }, 3000);
              }
            })
            .catch((err) => {
              console.log("error", err);
            });
        }
      } else if (type === "others") {
        this.file_other = file;
        this.upload_other_show = false;

        if (this.toggle_edit == true) {
          let formData = new FormData();
          formData.append("other_support_document", this.file_other);
          axios
            .patch(
              `${process.env.VUE_APP_API}/update/other-support-document/${this.userInfo.data.user.id}/?Key=${this.userInfo.data.token}`,
              formData
            )

            .then((resp) => {
              if (resp.data.status == 200) {
                this.message = resp.data.message;
                // this.submitAdditional = true;
                // this.disableStatus = true;
                this.fetchOthers();
                setTimeout(() => {
                  this.message = "";
                }, 3000);
              }
            })
            .catch((err) => {
              console.log("error", err);
            });
        }
      } else if (type === "aadhar") {
        this.file_aadhar = file;
        this.upload_aadhar_show = false;

        if (this.toggle_edit == true) {
          let formData = new FormData();
          formData.append("upload_aadhar", this.file_aadhar);
          axios
            .patch(
              `${process.env.VUE_APP_API}/update/aadhar_upload/${this.userInfo.data.user.id}/?Key=${this.userInfo.data.token}`,
              formData
            )

            .then((resp) => {
              if (resp.data.status == 200) {
                this.message = resp.data.message;
                // this.submitAdditional = true;
                // this.disableStatus = true;
                this.fetchAadhar();
                setTimeout(() => {
                  this.message = "";
                }, 3000);
              }
            })
            .catch((err) => {
              console.log("error", err);
            });
        }
      } else if (type === "pan") {
        this.file_pan = file;
        this.upload_pan_show = false;
        console.log("entered pan update");
        if (this.toggle_edit == true) {
          let formData = new FormData();
          formData.append("upload_pan", this.file_pan);
          console.log("entered pan update");
          axios
            .patch(
              `${process.env.VUE_APP_API}/update/pancard_upload/${this.userInfo.data.user.id}/?Key=${this.userInfo.data.token}`,
              formData
            )

            .then((resp) => {
              if (resp.data.status == 200) {
                this.message = resp.data.message;
                // this.submitAdditional = true;
                // this.disableStatus = true;
                this.fetchPan();
                setTimeout(() => {
                  this.message = "";
                }, 3000);
              }
            })
            .catch((err) => {
              console.log("error", err);
            });
        }
      }
    },
    submitDocument() {
      let formData = new FormData();
      formData.append("passport_photo", this.file_photo);
      formData.append("dob_proof", this.file_birth);
      formData.append("tenth_marksheet", this.file_sslc);
      formData.append("twelth_marksheet", this.file_hsc);
      formData.append("caste_certificate", this.file_caste);
      formData.append("kyc_proof", this.file_kyc);
      formData.append("other_support_document", this.file_other);
      formData.append("upload_aadhar", this.file_aadhar);
      formData.append("upload_pan", this.file_pan);

      console.log("formData 461", formData);
      if (this.toggle_edit == false) {
        axios
          .post(
            `${process.env.VUE_APP_API}/document-create/?Key=${this.userInfo.data.token}`,
            formData
          )
          .then((resp) => {
            if (resp.data.status == 200) {
              this.message = resp.data.message;
              this.submitAdditional = true;
              this.disableStatus = true;
              this.$emit("formCompleted");
              this.fetchDocuments();
              setTimeout(() => {
                this.message = "";
              }, 3000);
            }
          })
          .catch((err) => {
            console.log("error", err);
          });
      } else {
        axios
          .put(
            `${process.env.VUE_APP_API}/document-update-retrieve/${this.userInfo.data.user.id}/?Key=${this.userInfo.data.token}`,
            formData
          )
          .then((resp) => {
            if (resp.data.status == 200) {
              this.message = resp.data.message;
              // this.submitAdditional = true;
              this.toggle_edit = false;
              this.disableStatus = true;
              setTimeout(() => {
                this.message = "";
              }, 3000);
            }
          })
          .catch((err) => {
            console.log("error", err);
          });
      }
    },
    async fetchDocuments() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/document-update-retrieve/${this.userInfo.data.user.id}/?Key=${this.userInfo.data.token}`,
          { responseType: "blob" }
        );
        const responseData = JSON.parse(await response.data.text());
        const data = responseData.data;
        console.log("document", data);
        this.passport_photo = this.getFileUrl(data.passport_photo);
        this.dob = this.getFileUrl(data.dob_proof);
        this.tenth = this.getFileUrl(data.tenth_marksheet);
        this.tweleth = this.getFileUrl(data.twelth_marksheet);
        this.caste = this.getFileUrl(data.caste_certificate);
        this.kyc = this.getFileUrl(data.kyc_proof);
        this.others = this.getFileUrl(data.other_support_document);
        this.aadhar = this.getFileUrl(data.upload_aadhar);
        this.pan = this.getFileUrl(data.upload_pan);

        if (!data) {
          this.loader = false;
          console.error("No valid data received for documents.");
          return;
        }
        if (data.passport_photo) {
          this.loader = false;
          this.submitAdditional = true;
          this.disableStatus = true;
          this.upload_photo_show = true;
          this.upload_dob_show = true;
          this.upload_tenth_show = true;
          this.upload_tweleth_show = true;
          this.upload_caste_show = true;
          this.upload_kyc_show = true;
          this.upload_other_show = true;
          this.upload_aadhar_show = true;
          this.upload_pan_show = true;
        } else {
          this.submitAdditional = false;
          this.disableStatus = false;
        }
        if (data.is_form_three_filled) {
          this.submit_button = true;
        }
      } catch (err) {
        console.log("Error fetching documents:", err);
      }
      //       id: 10
      // ​
      // is_form_completed: true
      // ​
      // is_form_three_filled: true
    },
    async fetchPhoto() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/update/passport-photo/${this.userInfo.data.user.id}/?Key=${this.userInfo.data.token}`,
          { responseType: "blob" }
        );
        const responseData = JSON.parse(await response.data.text());
        const data = responseData.data;

        this.passport_photo = this.getFileUrl(data.passport_photo);

        if (!data) {
          console.error("No valid data received for documents.");
          return;
        }
        if (data.passport_photo) {
          this.upload_photo_show = true;
        }
      } catch (err) {
        console.log("Error fetching documents:", err);
      }
    },
    async fetchDob() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/update/dob-proof/${this.userInfo.data.user.id}/?Key=${this.userInfo.data.token}`,
          { responseType: "blob" }
        );
        const responseData = JSON.parse(await response.data.text());
        const data = responseData.data;
        this.dob = this.getFileUrl(data.dob_proof);
        if (!data) {
          console.error("No valid data received for documents.");
          return;
        }
        if (data.dob_proof) {
          this.upload_dob_show = true;
        }
      } catch (err) {
        console.log("Error fetching documents:", err);
      }
    },
    async fetchTenth() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/update/tenth-marksheet/${this.userInfo.data.user.id}/?Key=${this.userInfo.data.token}`,
          { responseType: "blob" }
        );
        const responseData = JSON.parse(await response.data.text());
        const data = responseData.data;
        this.tenth = this.getFileUrl(data.tenth_marksheet);

        if (!data) {
          console.error("No valid data received for documents.");
          return;
        }
        if (data.tenth_marksheet) {
          this.upload_tenth_show = true;
        }
      } catch (err) {
        console.log("Error fetching documents:", err);
      }
    },
    async fetchTweleth() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/update/twelth-marksheet/${this.userInfo.data.user.id}/?Key=${this.userInfo.data.token}`,
          { responseType: "blob" }
        );
        const responseData = JSON.parse(await response.data.text());
        const data = responseData.data;
        this.tweleth = this.getFileUrl(data.twelth_marksheet);

        if (!data) {
          console.error("No valid data received for documents.");
          return;
        }
        if (data.twelth_marksheet) {
          this.upload_tweleth_show = true;
        }
      } catch (err) {
        console.log("Error fetching documents:", err);
      }
    },
    async fetchCaste() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/update/caste-certificate/${this.userInfo.data.user.id}/?Key=${this.userInfo.data.token}`,
          { responseType: "blob" }
        );
        const responseData = JSON.parse(await response.data.text());
        const data = responseData.data;
        this.caste = this.getFileUrl(data.caste_certificate);
        if (!data) {
          console.error("No valid data received for documents.");
          return;
        }
        if (data.caste_certificate) {
          this.upload_caste_show = true;
        }
      } catch (err) {
        console.log("Error fetching documents:", err);
      }
    },

    async fetchKyc() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/update/kyc-proof/${this.userInfo.data.user.id}/?Key=${this.userInfo.data.token}`,
          { responseType: "blob" }
        );
        const responseData = JSON.parse(await response.data.text());
        const data = responseData.data;
        this.kyc = this.getFileUrl(data.kyc_proof);

        if (!data) {
          console.error("No valid data received for documents.");
          return;
        }
        if (data.kyc_proof) {
          this.upload_kyc_show = true;
        }
      } catch (err) {
        console.log("Error fetching documents:", err);
      }
    },
    async fetchOthers() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/update/other-support-document/${this.userInfo.data.user.id}/?Key=${this.userInfo.data.token}`,
          { responseType: "blob" }
        );
        const responseData = JSON.parse(await response.data.text());
        const data = responseData.data;
        this.others = this.getFileUrl(data.other_support_document);

        if (!data) {
          console.error("No valid data received for documents.");
          return;
        }
        if (data.other_support_document) {
          this.upload_other_show = true;
        }
      } catch (err) {
        console.log("Error fetching documents:", err);
      }
    },
    async fetchAadhar() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/update/aadhar_upload/${this.userInfo.data.user.id}/?Key=${this.userInfo.data.token}`,
          { responseType: "blob" }
        );
        const responseData = JSON.parse(await response.data.text());
        const data = responseData.data;
        console.log("aadhar fetch", data);
        this.aadhar = this.getFileUrl(data.upload_aadhar);

        if (!data) {
          console.error("No valid data received for documents.");
          return;
        }
        if (data.upload_aadhar) {
          this.upload_aadhar_show = true;
        }
      } catch (err) {
        console.log("Error fetching documents:", err);
      }
    },
    async fetchPan() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/update/pancard_upload/${this.userInfo.data.user.id}/?Key=${this.userInfo.data.token}`,
          { responseType: "blob" }
        );
        const responseData = JSON.parse(await response.data.text());
        const data = responseData.data;
        this.pan = this.getFileUrl(data.upload_pan);
        console.log("data fetch pan", data);

        if (!data) {
          console.error("No valid data received for documents.");
          return;
        }
        if (data.upload_pan) {
          this.upload_pan_show = true;
        }
      } catch (err) {
        console.log("Error fetching documents:", err);
      }
    },
    toggleEdit() {
      this.disableStatus = false;
      this.submitAdditional = false;
      this.toggle_edit = true;
    },

    getFileUrl(file) {
      return `${process.env.VUE_APP_API}${file}`;
    },
  },
};
</script>

<style></style>
